import type React from 'react'
import { formatBRL } from '~/helpers/formatCurrency'

/** Preço do frete: "Grátis" quando zero, o valor em reais no resto. Usado na PDP, no carrinho e no checkout. */
const ShippingPriceLabel: React.FC<{ price: number }> = ({ price }) =>
    price === 0 ? <span className="font-bold text-healthy-green">Grátis</span> : formatBRL(price)

export default ShippingPriceLabel
